const SYMBOLS: Record<string, string> = { GBP: '£', EUR: '€', USD: '$' }

export function currencySymbol(currency = 'GBP'): string {
  return SYMBOLS[currency] ?? ''
}

/** £412.5 → "£412.50"; whole amounts drop the pence: £550 → "£550" */
export function formatMoney(amount: number | null | undefined, currency = 'GBP'): string {
  if (amount == null) return '—'
  const whole = Number.isInteger(amount)
  return `${currencySymbol(currency)}${amount.toLocaleString('en-GB', {
    minimumFractionDigits: whole ? 0 : 2,
    maximumFractionDigits: 2,
  })}`
}

export function formatPct(pct: number | null | undefined): string {
  if (pct == null) return ''
  return `${Number.isInteger(pct) ? pct : pct.toFixed(1)}% off`
}

export function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })
}

export const PAYMENT_LABELS: Record<string, string> = {
  card: 'Card',
  apple_pay: 'Apple Pay',
  google_pay: 'Google Pay',
}
